import React, { useState } from 'react'
import { trackEvent } from '../../utils/tracking/mixpanel'
import { useMatchScreen } from '../../context/MatchScreenContext'
import { FeedbackTextareaProps } from '../../utils/types'
import '../../styles/FeedbackModule/FeedbackModule.scss'

const FeedbackTextarea = ({
  question,
  onThanksMessage,
  expanded
}: FeedbackTextareaProps) => {
  const [comment, setComment] = useState('')
  const { state: { pageKey } } = useMatchScreen()

  const handleCommentSubmit = () => {
    trackEvent('FeedbackModule', 'CSAT Comment', {
      page_key: pageKey,
      comment,
      question
    })
    onThanksMessage()
  }

  return (
        <div className={`feedback_textarea ${expanded ? 'feedback_textarea_expanded' : ''}`}>
            <p>What is the most important reason for that score? (optional)</p>
            <textarea
                value={comment}
                onChange={e => setComment(e.target.value)}
                maxLength={150}
            ></textarea>
            <button onClick={handleCommentSubmit}>Submit</button>
        </div>
  )
}

export default FeedbackTextarea
